<template>
  <div class="active-list">
    <div class="up-info">
      <div class="up-info-title">二维码列表-{{ param }}活动列表</div>
      <div class="up-info-mainInfo">
        <div class="left-img">
          <img :src="row.picAddress"/>
        </div>
        <div class="right-info">
          <span>店铺名称:{{ row.shopName }}</span>
          <span>联系人:{{ row.proposer }}</span>
          <span>联系电话:{{ row.shopPhone }}</span>
          <span>地址:{{ row.district+row.shopAddress }}</span>
        </div>
      </div>
    </div>
    <hr/>
    <div class="down-info">
      <div class="down-active" v-for="(item,index) in activesData" :key="index">
        <div class="down-left">
          <img :src="item.resource"/>
        </div>
        <div class="down-right">
          <div class="right-up-title">
            <span class="title">{{ item.projectId }}. {{ item.title }}</span>
            <el-popconfirm
              @onConfirm="delActive(item.id)"
              title="确定删除吗？">
              <el-button slot="reference" circle icon="el-icon-close"></el-button>
            </el-popconfirm>
            <!--                <span class="del-btn" @click="delActive(item.id)" icon="el-icon-close"><i class="el-icon-close"></i></span>-->

          </div>
          <div class="right-middle-des">
            <span>{{ item.description }}</span>
          </div>
          <div class="right-down">
            <div class="right-down-left">
              <span>累计扫码{{item.version}}次</span>
            </div>
            <div class="right-down-right">
              <el-switch
                @change="changeSwitch($event,item.id,index)"
                v-model="item.certainlyOut"
                active-color="#13ce66"
                inactive-color="#cccccc"></el-switch>
              <span style="margin-left: 2%;">必出</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="func-btn">
      <el-button type="primary" size="mini" @click="addActives">添加活动</el-button>
      <el-button type="primary" size="mini" @click="showClearDialog=true">清空所有</el-button>
    </div>
    <el-dialog :visible.sync="showClearDialog" title="提示">
      <div><span>以下活动将与{{param}}解除绑定</span></div>
      <el-table ref="unbindList" :data="activesData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50px" align="center"></el-table-column>
        <el-table-column prop="id" label="活动id" width="100px" align="center"></el-table-column>
        <el-table-column prop="title" label="活动标题" align="center"></el-table-column>
      </el-table>
      <div class="dialog-btn">
        <el-button @click="cancleClear">取消</el-button>
        <el-button type="primary" @click="confirmUnbindActives">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Dialog} from 'element-ui'

  Vue.use(Dialog)
  export default {
    name: "bind-active",
    data() {
      return {
        row: {},
        param: '',
        onOff: null,
        activesData: null,
        certainlyOuts: [],
        showClearDialog: false,
        unbindActives: [],
      }
    },
    methods: {
      getQrInfo() {
        this.$http.post(this, '/qrcode/getQrInfo', {param: this.param}).then(res => {
          this.row = res.data
        })
      },
      getActivesInfo() {
        let that = this
        this.$http.post(this, '/qrcode/getActives', {param: this.param}).then(res => {
          that.activesData = res.data.map(active => {
              return {
                id: active.id,
                title: active.title,
                description: active.description,
                certainlyOut: active.certainlyOut == 0 ? false : true,
                resource: active.resource,
                projectId: active.projectId,
                version: active.version
              }
            })
          }
        )
      },
      delActive(id) {
        let that = this
        this.$http.post(this, '/qrcode/active/delete', {id: id}).then(() => {
          that.getActivesInfo()
        })
      },
      changeSwitch($event, id, index) {
        let param = {
          openId: null,
          openRes: null,
          closeId: null,
          closeRes: null
        }
        if ($event) {
          // 将其他开关关闭，只开当前这个
          this.activesData.forEach(active => {
            if (active.id == id) {
              param['openId'] = id
              param['openRes'] = $event
              active.certainlyOut = true
            } else {
              if (active.certainlyOut) {
                param['closeId'] = active.id
                param['closeRes'] = false
              }
              active.certainlyOut = false
            }
          })
        } else {
          param['closeId'] = this.activesData[index].id
          param['closeRes'] = false
          // 将指定索引的必出设置成false
          this.activesData[index].certainlyOut = false
        }
        this.$http.post(this, '/qrcode/updateCertainlyOut', param)
      },
      handleSelectionChange(selection) {
        this.unbindActives = selection.map(s => {
          return s.id
        })
      },
      confirmUnbindActives() {
        this.$http.post(this, '/qrcode/batchUnbindActives', {}, this.unbindActives)
        this.showClearDialog = false
        this.getActivesInfo()
      },
      cancleClear() {
        this.showClearDialog = false
        this.$refs.unbindList.clearSelection()
        this.unbindActives = []
      },
      addActives() {
        this.$router.push({path: '/qrcode/addAactive', query: {param: this.param}});
      },
    },
    mounted() {
      this.param = this.$route.query.param
      this.getActivesInfo()
      this.getQrInfo()
    }
  }
</script>

<style scoped>

  .up-info-title {
    font-size: 25px;
    font-weight: 600;
  }

  .up-info-mainInfo {
    display: flex;
    margin: 1% 0px;
  }

  .left-img {
    width: 10%;
  }

  .left-img img {
    width: 100%;
    border-radius: 20px;
    display: block;
  }

  .right-info {
    margin-left: 1%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .right-info span {
    font-size: 15px;
    font-weight: 400;
  }

  .down-info {
    display: flex;
    flex-wrap: wrap;
  }

  .down-active {
    background-color: rgba(0, 0, 0, 0.05);
    width: 46%;
    height: 15vh;
    padding: 1%;
    margin: 1%;
    display: flex;
    justify-content: space-around;
    border-radius: 3px;
  }

  .down-left {
    width: 15%;
    display: flex;
  }

  .down-left img {
    width: 100%;
    border-radius: 7px;
  }

  .down-right {
    width: 85%;
    display: flex;
    flex-direction: column;
    padding: 0px 1%;
    justify-content: space-between;
  }

  .right-up-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .right-up-title .el-button {
    font-size: 20px;
    border: 0px;
    background-color: #f2f2f2;
  }

  .right-up-title .title {
    width: 80%
  }

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 15px;
    font-weight: 600;
  }

  .right-middle-des {
    width: 80%;
    display: flex;
  }

  .right-down {
    display: flex;
    width: 100%;
  }

  .right-down-left {
    width: 50%;
  }

  .right-down-right {
    width: 50%;
    display: flex;
    justify-content: flex-end;
  }

  .func-btn {
    margin-left: 1%;
  }

  .dialog-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 2% 0px;
  }
</style>
